module.exports = __webpack_public_path__ + "static/media/Cairo-Bold.0a7ace89.woff2";